'use strict';

import React         from 'react';
import {Link}        from 'react-router';
import DocumentTitle from 'react-document-title';
import * as Connections from "../../utils/Connections.js";
import CompletedOrdersStore from "../../stores/CompletedOrdersStore.js";

// const propTypes = {
//     currentUser: React.PropTypes.object
// };

class CompletedOrders extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            allOrders:[],
            filteredOrders:[]
        };
        this.updateCompletedOrders=this.updateCompletedOrders.bind(this);

    }
    componentWillMount() {
        this.setState({
            allOrders:CompletedOrdersStore.getAll(),
            filteredOrders:CompletedOrdersStore.getFiltered()
        });
        CompletedOrdersStore.on("change",this.updateCompletedOrders);
        Connections.getCompletedOrders();
    }
    updateCompletedOrders(){
        this.setState({
            allOrders:CompletedOrdersStore.getAll(),
            filteredOrders:CompletedOrdersStore.getFiltered()
        });
    }
    getImageName(imageName){
        return Connections.getProduceImageLink() +imageName.replace(" ","").toLowerCase()+".jpg";

    }
    render() {
        return (
            <DocumentTitle title="Khula - Billing">
                <div className="main-content">

                    <div className="uk-overflow-auto">
                        <table className="uk-table uk-table-hover uk-table-responsive uk-table-middle uk-table-divider">
                            <thead>
                            <tr>
                                <th className="uk-table-shrink"></th>
                                <th className="uk-table-shrink">Produce</th>
                                <th className="uk-table-expand">Quantity Accepted (KGs)</th>
                                <th className="uk-table-expand">Quantity Rejected (KGs)</th>
                                <th className="uk-width-small">Ordered Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.filteredOrders.map((order, i) =>
                                <tr key={order.order_id}>
                                    <td><img className="avalibleImage uk-preserve-width uk-border-circle" src={this.getImageName(order.produce)} width="40" alt=""/></td>
                                    <td className="">{order.produce}</td>
                                    <td className="uk-table-link">
                                        <span className="uk-link-reset">{order.acceptedQuantity} KGs</span>
                                    </td>
                                    <td className="uk-text-nowrap">{order.quantity-order.acceptedQuantity} KGs</td>
                                    <td className="uk-text-nowrap"><p className="uk-text-meta uk-margin-remove-top"><time>{order.inserted_on}</time></p></td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>

                </div>
            </DocumentTitle>
        );
    }

}

// CompletedOrders.propTypes = propTypes;

export default CompletedOrders;



// WEBPACK FOOTER //
// ./src/pages/HopePageBabies/CompletedOrders.js